<template >
    <aside id="secondary" class="widget-area" v-if="recentlyData">
        <section id="woocommerce_recently_viewed_products-2" class="widget woocommerce widget_recently_viewed_products">
            <h2 class="widget-title">Also Recently Viewed</h2>
            <ul class="product_list_widget">
                <div class="kst-recently-product">
                    <CarouselProduction
                        :loop="false"
                        :modules="modules"
                        :dataListing="recentlyData"
                        :slidesPerView="slidePerViews"
                        :slidesPerGroup="1"
                        :breakpoints="swiperBreakpoints"
                        :navigation="navigation"
                        :parentId="`secondary_carousel`"
                    />
                </div>
            </ul>
        </section>
    </aside>
</template>

<style lang="scss">
    @import "@/assets/scss/components/product/_alsorecently.scss";
</style>

<script setup lang="ts">
    import { Navigation, Pagination } from "swiper/modules";
    import CarouselProduction from "~/components/Product/CarouselProduction.vue";
    const items = ref();
    const props = defineProps(["data"]);
    // watch(() => props.data, (recentlyData) => {
    //     items.value = recentlyData;
    // }, { immediate: true });
    const recentlyData = computed(() => props.data);
    const slidePerViews = recentlyData.value.length;
    const swiperBreakpoints = {
        320: {
            slidesPerView: 1.5,
            spaceBetween: 20,
        },
        640: {
            slidesPerView: 1.5,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
        1024: {
            slidesPerView: 5,
            spaceBetween: 8,
        },
    };
    const navigation = ref(true);
    const modules = [Navigation];

    import Splide from "@splidejs/splide"
    onMounted(() => {
        // onMounted
    });
</script>